import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=5835bf4d&scoped=true"
import script from "./MyAccount.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MyAccount.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=5835bf4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835bf4d",
  null
  
)

export default component.exports